import { BsModalRef } from 'ngx-bootstrap/modal'

import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core'
import { Organization } from '../organization'
import { AppState } from 'src/app/core/core.state'
import { Store } from '@ngrx/store'
import { organizationActions } from '../organization.actions'
import { Actions, ofType } from '@ngrx/effects'
import { NotificationService } from 'src/app/core/notification.service'
import { of } from 'rxjs'
import { take, timeout, catchError } from 'rxjs/operators'
import { persistentUserRoleSelectors } from '../../role/user-role/persistent-user-role/persistent-user-role.selector'
import { environment } from 'src/environments/environment'

@Component({
  templateUrl: './show.component.html',
  styleUrls: ['./show.component.scss']
})
export class OrganizationCreateModalComponent implements OnInit {
  @Input() title: string
  @Input() organization: Partial<Organization>

  @Output()
  onCreatedOrganization: EventEmitter<Organization> = new EventEmitter()

  constructor(
    private bsModalRef: BsModalRef,
    private store: Store<AppState>,
    private actions$: Actions,
    private notifificationService: NotificationService
  ) {}

  ngOnInit() {
    this.organization = new Organization()
  }

  public cancel() {
    this.bsModalRef.hide()
  }

  public onSubmit(organization: Partial<Organization>) {
    this.store
      .select(persistentUserRoleSelectors.selectSelectedUserRole)
      .pipe(take(1))
      .subscribe((pUr) => {
        const siteId =
          pUr && pUr.siteId ? pUr.siteId : environment.defaultSiteId
        this.store.dispatch(
          organizationActions.createOne({
            entity: {
              ...organization,
              ...this.organization,
              siteId: siteId,
              requiresRegistrationApproval: false
            }
          })
        )
      })

    this.cancel()
    this.actions$
      .pipe(
        ofType(organizationActions.upsertMany),
        take(1),
        timeout(5000),
        catchError(() => of(null))
      )
      .subscribe((action) => {
        if (!action) {
          console.error('Failed to create sale before timeout')
          return false
        }

        this.onCreatedOrganization.emit(action.entities?.[0])
      })
  }
}
